// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_GcE","cls2":"LoswpPackPitch-cls2_r4E LoswpPackPitch-cls1_GcE"};